import React, { Component } from "react";
import axios from 'axios';
import api from '../api';
import Typography from '@material-ui/core/Typography';
import { makeStyles } from '@material-ui/core/styles';
import { withStyles } from "@material-ui/core/styles";
import Snackbar from '@material-ui/core/Snackbar';
import MuiAlert from '@material-ui/lab/Alert';
import TextField from '@material-ui/core/TextField';
import MenuItem from '@material-ui/core/MenuItem';
import InputAdornment from '@material-ui/core/InputAdornment';
import Button from '@material-ui/core/Button';
import NumberFormat from 'react-number-format';
import vehicle_movements_constants  from '../../../data/work-order-constants'
import IconButton from "@material-ui/core/IconButton";
import AddIcon from "@material-ui/icons/AddCircleOutline";

function Alert(props) {
  return <MuiAlert elevation={6} variant="filled" {...props} />;
}

const useStyles = theme => ({
  root: {
    flexGrow: 1,
    width: '100%',
  },
	appBar: {
    position: 'relative',
  },
  title: {
    marginLeft: '2rem',
    flex: 1,
    color: 'white'
  },
  paper: {
    padding: '2rem',
    textAlign: 'center',
  },
  checkedIcon:{
	  width: 16,
      height: 16,
  },
  option:{
  	  fontWeight: 600,
      fontSize:'0.75rem',
  },
  typography:{
	  fontSize: '0.75rem'
  },
  select:{
  	marginTop: '0',
  	marginRight:'12px',
  	padding: '0'
  },
  menu:{
  	fontSize: '0.75rem'
  }
});


class VehicleMovement extends React.Component {
    constructor(props) {
      	super(props);
		this.state = {transport_means:[],users:[],vehicle_movement:{work_order:{user_id:''},routes:[{}]},transport_means:[],snackbar:{open:false}, loading: true}
  	}

    async componentDidMount() {
    	var work_order_id = this.props.id
    	this.getUsers()
    	await this.getVehicleMovement(work_order_id)
    	await this.getTransportMeans()
    	this.setState({loading: false})
    }

    getUsers = () => {
		const token = localStorage.getItem('userToken')
		return axios
	     .get(api.work_order().users(),{ headers: {"Authorization" : `Bearer ${token}`} })
	      .then(res => {
	      		res.data.push({id:0, name:'Otro'})
	      		this.setState({users: res.data})
	      })
	      .catch(err =>{console.log(err)
	      })
    
    }

    getTransportMeans = async() => {
		const token = localStorage.getItem('userToken')
		return await axios
	     .get(api.vehicle_movements().transport_means(),{ headers: {"Authorization" : `Bearer ${token}`} })
	      .then(res => {
	      		this.setState({transport_means: res.data})
	      })
	      .catch(err =>{console.log(err)
	      })

    }

   	async getVehicleMovement(id){
		const token = localStorage.getItem('userToken')
		return await axios
	     .get(api.vehicle_movements().get(id),{ headers: {"Authorization" : `Bearer ${token}`} })
	      .then(res => {
	      		res.data.start_date = (res.data.start_date) ? res.data.start_date.replace(' ','T') : ''
	      		res.data.end_date = (res.data.end_date) ? res.data.end_date.replace(' ','T') : ''
	      		var vehicle_movement = res.data
	      		vehicle_movement.origin_place = res.data.routes[0].origin_place
	      		vehicle_movement.destiny_place = res.data.routes[0].destiny_place
	      		if (res.data.routes[0].user_id === res.data.work_order.user_id){
	      			res.data.routes.push({})
	      		}
	      		this.setState({vehicle_movement: vehicle_movement, loading: false})
	      })
	      .catch(err =>{console.log(err)
	      })
    }

    handleChange = (e) =>{
    	var vehicle_movement = this.state.vehicle_movement
    	if (e.target.name === 'total_cost'){
    		e.target.value = e.target.value.replace('$','')
    	}
    	vehicle_movement[e.target.name] = e.target.value
    	this.setState({vehicle_movement: vehicle_movement})
    }

    handleRouteChange = (e) => {
    	var vehicle_movement = this.state.vehicle_movement
		var element = e.target.name.split('.')
		var key = element[0]
		var id = element[1]
    	vehicle_movement.routes[id][key] = e.target.value
    	this.setState({vehicle_movement: vehicle_movement})
    }

    handleSubmit = () => {
	    var formData = new FormData();
	    var url = api.vehicle_movements().post();
	    formData.set("vehicle_movement[work_order_id]", this.props.id);
	    formData.set("vehicle_movement[start_date]", (this.state.vehicle_movement.start_date) ? this.state.vehicle_movement.start_date : '');
	    formData.set("vehicle_movement[end_date]", (this.state.vehicle_movement.end_date) ? this.state.vehicle_movement.end_date : '');
	    formData.set("vehicle_movement[description]", (this.state.vehicle_movement.description) ? this.state.vehicle_movement.description : '');
	    formData.set("vehicle_movement[requirements]", (this.state.vehicle_movement.requirements) ? this.state.vehicle_movement.requirements : '');
	    formData.set("vehicle_movement[transport_mean]", (this.state.vehicle_movement.transport_mean) ? this.state.vehicle_movement.transport_mean : '');
	    formData.set("vehicle_movement[total_cost]", (this.state.vehicle_movement.total_cost) ? this.state.vehicle_movement.total_cost : 0);
	    formData.set("vehicle_movement[comments]", (this.state.vehicle_movement.comments) ? this.state.vehicle_movement.comments : '');

	    this.state.vehicle_movement.routes.map((val,idx)=>{
		    if (val.user_id !== '' && val.user_id !== undefined || (val.external_user !== undefined && val.external_user !== '')){
			    formData.set("routes["+idx+"][origin_place]", (this.state.vehicle_movement.origin_place) ? this.state.vehicle_movement.origin_place : '');
			    formData.set("routes["+idx+"][destiny_place]", (this.state.vehicle_movement.destiny_place) ? this.state.vehicle_movement.destiny_place : '');
			    formData.set("routes["+idx+"][external_user]", (val.external_user) ? val.external_user : '');
			    formData.set("routes["+idx+"][user_id]", (val.user_id) ? val.user_id : '');
			    formData.set("routes["+idx+"][id]", (val.id) ? val.id : '');
		    }
	    })

	    if (this.state.vehicle_movement.id !== undefined) {
	    	url = api.vehicle_movements().patch(this.props.id)
		    formData.set("vehicle_movement[id]", this.state.vehicle_movement.id);
		    formData.set("_method", 'PATCH');
	    }
	    let self = this
	    const token = localStorage.getItem('userToken')
	    axios.post(url,
	       formData,
	       {headers: {'Content-Type': 'multipart/form-data',"Authorization" : `Bearer ${token}`}}
	       )
	      .then((response)=> {
	      		var snackbar = {open: true, success_message: 'Movimiento cargado con éxito', severity: 'success'}
		  		self.setState({ snackbar: snackbar})

	      })
	      .catch(function (error) {
//	      		var error_message = 'Ha ocurrido un error al cargar el movimiento. Por favor contacte con su administrador'
	      		var error_message = ''
	      		var errors = error.response.data
				if (errors.errors){
					if (errors.status_code !== 404){
					  var keys = Object.keys(errors.errors); 
					  for(var i = 0; i < keys.length; i++) {   
					    var key = (keys[i]) ; 
					    var key_errors = errors.errors[key]
					    key_errors.map((val,idx)=>{
					      error_message = error_message.concat(val).concat(' ')
					    })
					  }
					} else {
				      error_message = error_message.concat(error.message).concat(' ')
					}
				}

	      		var snackbar = {open: true, success_message: error_message, severity: 'warning'}
		  		self.setState({ snackbar: snackbar})
	    })
    }

    handleSnackbar = () => {
    	var snackbar = this.state.snackbar
    	snackbar.open = !snackbar.open
    	this.setState({snackbar: snackbar})
    }

    handleAddNewRoute = () => {
    	var vehicle_movement = this.state.vehicle_movement
    	vehicle_movement.routes.push({})
    	this.setState({vehicle_movement:vehicle_movement})
    }

	render() {
		const { origin_destinies, reasons } = vehicle_movements_constants().vehicle_movements
		var vehicle_movement = this.state.vehicle_movement
		var transport_means = this.state.transport_means
		const classes = this.props.classes;
		return (
			<React.Fragment>
				<Snackbar open={this.state.snackbar.open} autoHideDuration={10000} onClose={this.handleSnackbar}>
					<Alert onClose={this.handleSnackbar} severity={this.state.snackbar.severity}>
					  {this.state.snackbar.success_message}
					</Alert>
				</Snackbar>
				{(this.state.loading)
					?
					''
					:
					<React.Fragment>
						<div className="row mt-2"> 
							<TextField
								id="origin_place"
								name="origin_place"
								value={vehicle_movement.origin_place}
								onChange={this.handleChange}
								select
								margin="normal"
								className="m-0 p-0 mr-2"
								InputLabelProps={{
									shrink: true
								}}
								inputProps={{style:{minWidth: 150, fontSize: '0.75rem'}}}
								InputProps={{
								    startAdornment: <InputAdornment position="start" ><Typography variant="caption">Origen</Typography></InputAdornment>,
							        style:{fontSize: '0.75rem'}
								}}
							>
							  {origin_destinies.map((option) => (
							    <MenuItem key={option} value={option} className={classes.menu} style={{fontSize: '0.75rem'}}>
							      {option}
							    </MenuItem>
							  ))}
							</TextField>							
							<TextField
								id="destiny_place"
								name="destiny_place"
								value={vehicle_movement.destiny_place}
								onChange={this.handleChange}
								select
								margin="normal"
								className="m-0 p-0 mr-2"
								InputLabelProps={{
									shrink: true
								}}
								inputProps={{style:{minWidth: 150, fontSize: '0.75rem'}}}
								InputProps={{
								    startAdornment: <InputAdornment position="start" ><Typography variant="caption">Destino</Typography></InputAdornment>,
							        style:{fontSize: '0.75rem'}
								}}
							>
							  {origin_destinies.map((option) => (
							    <MenuItem key={option} value={option} className={classes.menu} style={{fontSize: '0.75rem'}}>
							      {option}
							    </MenuItem>
							  ))}
							</TextField>							
							<TextField
								id="start_date"
								value={vehicle_movement.start_date}
								onChange={this.handleChange}
								type="datetime-local"
								name="start_date"
								margin="normal"
								className="m-0 p-0 mr-2"
								InputLabelProps={{
									shrink: true
								}}
								inputProps={{style:{minWidth: 70, fontSize: '0.75rem'}}}
								InputProps={{
								    startAdornment: <InputAdornment position="start" ><Typography variant="caption">Fecha desde</Typography></InputAdornment>,
								}}
							/>		
							<TextField
								id="end_date"
								value={vehicle_movement.end_date}
								onChange={this.handleChange}
								type="datetime-local"
								name="end_date"
								margin="normal"
								className="m-0 p-0 mr-2"
								InputLabelProps={{
									shrink: true
								}}
								inputProps={{style:{minWidth: 70, fontSize: '0.75rem'}}}
								InputProps={{
								    startAdornment: <InputAdornment position="start" ><Typography variant="caption">Fecha hasta</Typography></InputAdornment>,
								}}
							/>	
							<TextField
								id="description"
								name="description"
								value={vehicle_movement.description}
								onChange={this.handleChange}
								select
								margin="normal"
								className="m-0 p-0 mr-2"
								InputLabelProps={{
									shrink: true
								}}
								inputProps={{style:{minWidth: 150, fontSize: '0.75rem'}}}
								InputProps={{
								    startAdornment: <InputAdornment position="start" ><Typography variant="caption">Motivo</Typography></InputAdornment>,
							        style:{fontSize: '0.75rem'}
								}}
							>
							  {reasons.map((option) => (
							    <MenuItem key={option} value={option} className={classes.menu} style={{fontSize: '0.75rem'}}>
							      {option}
							    </MenuItem>
							  ))}
							</TextField>							
		
							<TextField
								id="requirements"
								value={vehicle_movement.requirements}
								onChange={this.handleChange}
								type="text"
								name="requirements"
								margin="normal"
								className="m-0 p-0 mr-2"
								InputLabelProps={{
									shrink: true
								}}
								inputProps={{style:{minWidth: 200, fontSize: '0.75rem'}}}
								InputProps={{
								    startAdornment: <InputAdornment position="start" ><Typography variant="caption">Requerimientos</Typography></InputAdornment>,
								}}
							/>		
							<TextField
								id="transport_mean"
								name="transport_mean"
								select
								margin="normal"
								className={classes.select}
								InputLabelProps={{
									shrink: true
								}}
								  	onChange={this.handleChange}
							    value={vehicle_movement.transport_mean}
								inputProps={{style:{minWidth: 150, fontSize: '0.75rem'}}}
							  	InputProps={{
							        startAdornment: <InputAdornment position="start" ><Typography variant="caption" style={{width: 105}}>Tipo de transporte</Typography></InputAdornment>,
							        style:{fontSize: '0.75rem'}
									}}
							>
							  {transport_means.map((option) => (
							    <MenuItem key={option} value={option} className={classes.typography}>
							      {option}
							    </MenuItem>
							  ))}
							</TextField>
							<NumberFormat 
								id="total_cost"
								name="total_cost"
								value={vehicle_movement.total_cost}
								onChange={this.handleChange}
								className="m-0 p-0"
							    InputProps={{style: {minWidth: 70,fontSize: '0.75rem'}}}
							    decimalSeparator='.'
							    prefix={'$'}
							    customInput={TextField}  
							    InputLabelProps={{
							      shrink: true,
							    }}
							  	InputProps={{
							        startAdornment: <InputAdornment position="start" ><Typography variant="caption">Costo</Typography></InputAdornment>,
							        style:{fontSize: '0.75rem'}
									}}
							    isAllowed={(values) => {
					              let { floatValue } = values;
					              floatValue = (floatValue !== undefined) ? floatValue : 0
							      return floatValue >= 0 && floatValue < 99999999;
							    }}            

								/>								          
						</div>
						<div className="row mt-2">
							<Typography>Otro usuario involucrado</Typography>
							<IconButton size="small" className={classes.iconButton} onClick={(e)=> {this.handleAddNewRoute(e)}}>
							    <AddIcon className={classes.deleteIcon}/>
							</IconButton>
						</div>
						{(this.state.vehicle_movement.routes.map((val,idx)=> {
							val.user_id = (val.user_id !== '') ? val.user_id : 0
							return (
								<div className="row mt-1">
									{(parseInt(this.state.vehicle_movement.work_order.user_id) !== parseInt(val.user_id))

									?
										<React.Fragment>
											<TextField
												id={"user_id."+idx}
												name={"user_id."+idx}
												value={val.user_id}
												onChange={this.handleRouteChange}
												select
												margin="normal"
												className="m-0 p-0 mr-2"
												InputLabelProps={{
													shrink: true
												}}
												inputProps={{style:{minWidth: 150, fontSize: '0.75rem'}}}
												InputProps={{
												    startAdornment: <InputAdornment position="start" ><Typography variant="caption">Usuario</Typography></InputAdornment>,
											        style:{fontSize: '0.75rem'}
												}}
											>
											  {this.state.users.map((option) => (
											    <MenuItem key={option.id} value={option.id} className={classes.menu} style={{fontSize: '0.75rem'}}>
											      {option.name}
											    </MenuItem>
											  ))}
											</TextField>
											{
												(val.user_id === '' || val.user_id === 0) 
												?
													<TextField
														id={"external_user."+idx}
														name={"external_user."+idx}
															value={val.external_user}
														onChange={this.handleRouteChange}
														type="text"
														margin="normal"
														className="m-0 p-0 mr-2"
														InputLabelProps={{
															shrink: true
														}}
														inputProps={{style:{minWidth: 200, fontSize: '0.75rem'}}}
														InputProps={{
														    startAdornment: <InputAdornment position="start" ><Typography variant="caption">Usuario Externo</Typography></InputAdornment>,
														}}
													/>
												:
													''
											}
										</React.Fragment>
									:
										''
									}
								</div>
							)
						}))}
						<div className="row mt-2">
							<TextField
								id="comments"
								value={vehicle_movement.comments}
								onChange={this.handleChange}
								type="text"
								fullWidth
								name="comments"
								margin="normal"
								className="m-0 p-0 mr-2"
								InputLabelProps={{
									shrink: true
								}}
								inputProps={{style:{fontSize: '0.75rem'}}}
								InputProps={{
								    startAdornment: <InputAdornment position="start" ><Typography variant="caption">Comentarios</Typography></InputAdornment>,
								}}
							/>	
						</div>	
						<div className="row mt-2">
							<Button className="mt-1" variant="contained" color="primary" size="small" style={{fontSize: '0.75rem'}} onClick={(e)=>{this.handleSubmit(e)}}>{(this.state.vehicle_movement.id) ? 'Guardar' : 'Cargar'}</Button>
						</div>
					</React.Fragment>
				}
			</React.Fragment>
		)
	}

}

export default withStyles(useStyles)(VehicleMovement);

